import { TFunction } from 'i18next'
import { z } from 'zod'

export const makeSwiftlaneConnectionSchema = (t: TFunction<['organisation', 'common']>) =>
  z.object({
    authToken: z.string().min(1, t('organisation:places.integrations.swiftlane.errors.authToken')),
    config: z.string().min(1, t('organisation:places.integrations.swiftlane.errors.config')),
    swiftlaneAccountName: z
      .string()
      .min(1, t('organisation:places.integrations.swiftlane.errors.accountName')),
  })

export type SwiftlaneConnectionFormValues = z.infer<
  ReturnType<typeof makeSwiftlaneConnectionSchema>
>

export const swiftlaneDefaultValues: SwiftlaneConnectionFormValues = {
  authToken: '',
  config: '',
  swiftlaneAccountName: '',
}
